/**
 * Bare, dependency-free route/page loader. Renders the same visual as the ui-v3 <Spinner /> — the
 * LoadingDIcon "extended" arc, spinning in the brand colour — but inlines the SVG directly instead
 * of importing it from @prophecy/icons. Importing any icon would pull the entire app-icons chunk
 * (~505 KB) into the eager bundle of every consumer (here: MainApp's route Suspense + UserProvider).
 *
 * Reuses index.html's global CSS: `make-this-box-center` for full-area centering and the global
 * `@keyframes rotate` (0deg→360deg) — identical to @prophecy/theme's `rotate`, which the real
 * Spinner uses at `1s linear infinite`. Colour is the live `--var-colors-brand600` theme variable.
 */
export function ProphecyLoader() {
  return (
    <div className='make-this-box-center'>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={{ animation: 'rotate 1s linear infinite' }}>
        <path
          d='M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2'
          stroke='var(--var-colors-brand600)'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </div>
  );
}
